function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getSectionInnerHTML(html, selector) {
  const element = new DOMParser().parseFromString(html, "text/html");
  if (selector) {
    return element.querySelector(selector).innerHTML;
  }
  return element.body.innerHTML;
}

function buildKeysWithQuantity(keys, quantity, customQuantitiesByKey = {}) {
  return keys.reduce((acc, key) => {
    if (key) {
      acc[key] = quantity;
      if (customQuantitiesByKey[key]) {
        acc[key] = acc[key] * customQuantitiesByKey[key];
      }
    }
    return acc;
  }, {});
}

class CartQuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelector("button[name='plus']").addEventListener("click", this.onPlusButtonClick.bind(this));
    this.querySelector("button[name='minus']").addEventListener("click", this.onMinusButtonClick.bind(this));
  }

  onPlusButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.input.stepUp();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  onMinusButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("cart-quantity-input", CartQuantityInput);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const keys = this.dataset.keys ? this.dataset.keys.split(";") : [this.dataset.key];
      const keysWithQuantity = buildKeysWithQuantity(keys, 0);
      this.closest("cart-container").updateQuantities(keysWithQuantity);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class Cart extends HTMLElement {
  constructor() {
    super();

    this.drawer = document.getElementById("cart");
    this.sectionId = this.dataset.sectionId;

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

  }

  onChange(event) {
    const quantity = event.target.value;
    const keys = event.target.dataset.keys ? event.target.dataset.keys.split(";") : [event.target.dataset.key];
    let customQuantitiesByKey = {};
    if (event.target.dataset.quantities) {
      const customQuantities = event.target.dataset.quantities.split(";");
      for (let i = 0; i < customQuantities.length; i++) {
        const customQuantity = customQuantities[i];
        const [key, quantity] = customQuantity.split("=");
        if (key && quantity) {
          customQuantitiesByKey[key] = parseInt(quantity);
        }
      }
    }
    const quantitiesByKey = buildKeysWithQuantity(keys, quantity, customQuantitiesByKey);
    this.updateQuantities(quantitiesByKey);
  }

  updateQuantities(quantitiesByKey) {

    const body = {
      updates: quantitiesByKey,
      sections: [this.sectionId, 'cart__counter', 'cart__empty'],
      sections_url: window.location.pathname
    };

    fetch(`${window.routes.cart_update_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(body),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.item_count === 0) {
          return window.location.reload();
        }
        window.recentCartUpdates = true;
        if (res.sections && res.sections[this.sectionId]) {
          this.refreshCart(res.sections[this.sectionId]);
        }
        if (res.sections && res.sections['cart__empty']) {
          this.refreshCartEmpty(res.sections['cart__empty']);
        }
        if (res.sections && res.sections["cart__counter"]) {
          const updatedCount = getSectionInnerHTML(res.sections["cart__counter"]);
          const cartCounters = document.querySelectorAll("cart-counter");
          cartCounters.forEach((cartCounter) => {
            cartCounter.innerHTML = updatedCount;
          });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.classList.remove("loading");
      });
  }

  refreshCart(freshSection) {
    this.innerHTML = getSectionInnerHTML(freshSection, "cart-container");
  }

  refreshCartEmpty(freshSection) {
    const cartEmpty = document.getElementById("cart-empty");
    if (cartEmpty) cartEmpty.innerHTML = getSectionInnerHTML(freshSection, "#cart-empty");
  }

}

customElements.define("cart-container", Cart);
